import { Injectable } from '@angular/core';

import { Workflow } from '@blaze-shared/workflow-domain';

import { EngineState } from '../../+state/engine';

export type AiUndoState = Pick<
  EngineState,
  'connections' | 'entities' | 'ids' | 'schemas' | 'workflows'
>;

@Injectable({ providedIn: 'root' })
export class AiUndoService {
  private state: AiUndoState | undefined;

  saveState(state: AiUndoState): void {
    this.state = structuredClone(state);
  }

  getState(): AiUndoState | undefined {
    return this.state;
  }

  findDeletedWorkflows(currentWorkflows: Workflow[], previousWorkflows: Workflow[]): string[] {
    const currentIds = new Set(currentWorkflows.map((w) => w.id));
    return previousWorkflows.filter((w) => !currentIds.has(w.id)).map((w) => w.id);
  }
}
